import { render, staticRenderFns } from "./EventOutcomeTask.vue?vue&type=template&id=28069419&scoped=true"
import script from "./EventOutcomeTask.vue?vue&type=script&lang=ts"
export * from "./EventOutcomeTask.vue?vue&type=script&lang=ts"
import style0 from "./EventOutcomeTask.vue?vue&type=style&index=0&id=28069419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28069419",
  null
  
)

export default component.exports